import { FunctionComponent, useCallback, useRef, useState } from 'react'

import styled, { css } from 'styled-components'

import { desktopCSS } from '@measures/responsive'
import useFmtRelevantMatches from '@hooks/useFmtRelevantMatches'
import SwiperArrows from '@components/FollowMyTeamOverview/FollowMyTeamOverviewWithSubscriptions/SwiperArrows'
import Tile from '@components/RelatedMatches/Tile'
import Swiper, { ArrowsVisibilityType, SwiperClass } from '@components/Swiper'

const MIN_ITEMS_FOR_ARROWS = 3

type SwiperArrowsProps = {
  itemsCount: number
}

type RelevantMatchesProps = {
  validCompetitorIds: string[]
}

const Wrapper = styled.div`
  ${desktopCSS(css`
    min-height: 143px;
  `)}
`

const StyledSwiperArrows = styled(SwiperArrows)<SwiperArrowsProps>`
  ${({ itemsCount }) => css`
    > * {
      right: 0;
    }

    ${itemsCount <= MIN_ITEMS_FOR_ARROWS &&
    css`
      display: none;
    `}
  `}
`

const RelevantMatches: FunctionComponent<RelevantMatchesProps> = ({
  validCompetitorIds,
}) => {
  const { data } = useFmtRelevantMatches({
    competitorIds: validCompetitorIds,
    typeOfSport: 'soccer',
  })

  const items = data?.items ?? []
  const swiperRef = useRef<SwiperClass | null>(null)
  const [arrowsVisibility, setArrowsVisibility] =
    useState<ArrowsVisibilityType>()

  const onInit = useCallback(
    (swiper: SwiperClass) => {
      swiperRef.current = swiper
    },
    [swiperRef],
  )

  const onArrowsVisibility = useCallback((arrow: ArrowsVisibilityType) => {
    setArrowsVisibility(arrow)
  }, [])

  return (
    <Wrapper>
      {items.length > 0 ? (
        <Swiper
          initialSlide={0}
          spaceTopBottom={0}
          slidesPerGroup={1}
          spaceBetween={8}
          onInit={onInit}
          onArrowsVisibility={onArrowsVisibility}
          slides={items.map((item) => (
            <Tile
              key={`${item.typeOfSport}-${item.matchId}`}
              matchId={item.matchId}
              typeOfSport={item.typeOfSport}
              link={item.link}
            />
          ))}
        >
          {arrowsVisibility && arrowsVisibility !== 'none' && (
            <StyledSwiperArrows
              swiperRef={swiperRef}
              arrowsVisibility={arrowsVisibility}
              itemsCount={items.length}
            />
          )}
        </Swiper>
      ) : null}
    </Wrapper>
  )
}

export default RelevantMatches
